<template>
    <b-modal
        id="ModalUpdateArboSnapshot"
        size="xl"
        title="Modifier un instantané"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        hide-footer
    >
        <FormArboSnapshot
            :projectid="projectid"
            :arbosnapshot="arbosnapshot"
            @saved="onSaved"
            class="mb-4"
        />
    </b-modal>
</template>
<script>
import FormArboSnapshot from "@/components/model/arbosnapshot/FormArboSnapshot";
export default {
    components: {
        FormArboSnapshot,
    },

    props: {
        projectid: { type: [String, Number] },
        arbosnapshot: { type: Object },
    },

    methods: {
        onSaved() {
            this.$bvModal.hide("ModalUpdateArboSnapshot");
            this.$emit("saved");
        },
    },
};
</script>
